import { render, staticRenderFns } from "./TabellaCausaliScarto.vue?vue&type=template&id=1dbab6e3&scoped=true&"
import script from "./TabellaCausaliScarto.vue?vue&type=script&lang=js&"
export * from "./TabellaCausaliScarto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbab6e3",
  null
  
)

export default component.exports